import { Component, Input } from '@angular/core';
import { PlIcon } from '@app/icon-library/icons';

export enum IconColor {
  blue = 'text-pl-blue-500',
  gray400 = 'text-pl-gray-400',
  green = 'text-pl-green-500',
  white = 'text-white',
}

export enum BackgroundColor {
  black = 'bg-black',
  gray500 = 'bg-pl-gray-500',
  gray700 = 'bg-pl-gray-700',
  plBlack = 'bg-pl-black',
}

export interface MenuItemComponentInputs {
  backgroundColor: BackgroundColor;
  description: string | null;
  iconLeft: PlIcon | null;
  iconLeftColor: IconColor | null;
  iconRight: PlIcon | null;
  isLocked: boolean;
  orangeSubtitle: boolean;
  subtitle: string | null;
  title: string | null;
}

@Component({
  selector: 'pl-menu-item',
  templateUrl: './menuItem.component.html',
})
export class MenuItemComponent implements MenuItemComponentInputs {
  @Input() public backgroundColor: BackgroundColor = BackgroundColor.gray700;
  @Input() public description: string | null = null;
  @Input() public iconLeft: PlIcon | null = null;
  @Input() public iconLeftColor: IconColor | null = IconColor.white;
  @Input() public iconRight: PlIcon | null = null;
  @Input() public isLocked: boolean = false;
  @Input() public orangeSubtitle: boolean = false;
  @Input() public subtitle: string | null = null;
  @Input() public title: string | null = null;

  public readonly PlIcon: typeof PlIcon = PlIcon;
}
